var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('server-data',{attrs:{"method":_vm.getMeeting},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var serverData = ref.serverData;
return [_c('v-row',{staticClass:"mx-0"},[(loading)?_c('v-col',[_c('sdo-loader')],1):_vm._e(),(!loading && serverData)?_c('v-col',[_c('h2',[_vm._v("Урок: "+_vm._s(serverData.name))]),_c('jazz-sdk',{staticClass:"mb-5",attrs:{"meeting":serverData}})],1):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }